var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElephantLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 626,
    viewBox: "0 0 435 626",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 69.0001C101.9 28.2001 -11.1667 -11.4998 -101.5 5.50024L-281 713.027L433 698.027C429.333 687.361 424.2 645.027 433 561.027C444 456.027 306 598.027 341 527.527C376 457.027 147 624.527 58.5 602.527C-30 580.527 23 523.527 64.5 506.527C106 489.527 46 355.027 2 357.027C-42 359.027 54 230.528 136 230.528C218 230.528 33.5 120 71.5 69.0001Z",
    stroke: "#7750BF",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephantLine);
export default __webpack_public_path__ + "static/media/ElephantLine.dfc22b2b5a6a514467f88b2636d3137e.svg";
export { ForwardRef as ReactComponent };